// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7914f589","453":"cd8d39a4","455":"54fbac2a"}[chunkId] + ".chunk.js";
};